"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const core_1 = require("companion-app-components/utils/core");
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const SubscriptionAlert = ({ label, alertClass }) => {
    var _a;
    const { classes } = useStyles();
    return (<Alert_1.default icon={<img src={warning_svg_1.default} alt="alert" height={24} width={24}/>} className={(0, classnames_1.default)(classes.alert, alertClass)}>
      {label} 
      <a href={(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.pick_your_plan_url} className={classes.anchorStyle} target="_blank"> Renew Now! </a>
    </Alert_1.default>);
};
exports.default = SubscriptionAlert;
